import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Store } from "@ngrx/store";
import { TranslateModule } from "@ngx-translate/core";

import { DynamicDialogRef } from "primeng/dynamicdialog";
import { ButtonModule } from "primeng/button";

import { selectQuoteId } from "src/app/store/pages/quote/quote.selectors";
import { DrawingActions } from "src/app/store/pages/quote/drawing/drawing.actions";

@Component({
    selector: "app-revoke-drawing-dialog",
    templateUrl: "./revoke-drawing-dialog.component.html",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule, ButtonModule],
})
export class RevokeDrawingDialogComponent {

    public readonly ref = inject(DynamicDialogRef);
    private readonly store = inject(Store);
    private readonly quoteId = toSignal(this.store.select(selectQuoteId));

    public confirm(): void {
        const id = this.quoteId();
        if (id) this.store.dispatch(DrawingActions.revokeDrawing({ quoteId: id }));
        this.ref.close();
    }

    public closeDialog(): void {
        this.ref.close();
    }
}
